"use client";

import { useEffect } from "react";
import { useAppSelector } from "@/app/store/hooks";
import { applyTheme, resolveTheme } from "@/app/store/themeSlice";

/**
 * Keeps <html class="dark"> in step with the stored preference, and, only while it is
 * `system`, with the OS (live, when the visitor flips their device theme).
 */
export function ThemeSync() {
  const preference = useAppSelector((s) => s.theme.preference);

  useEffect(() => {
    applyTheme(resolveTheme(preference));
    if (preference !== "system") return;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = () => applyTheme(resolveTheme("system"));
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [preference]);

  return null;
}
